import { Classes } from "@pinpointhq/thumbtack";
import * as React from "react";

/**
 * @deprecated Please use the Thumbtack version of this component
 * If it does not cover your use case please speak to Tom Luce
 */
export function DrawerBody(props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
  const { className, style, ...rest } = props;

  /**
   * I made some styling changes in Thumbtack that removed the margin entirely
   * I also added the `DrawerBody` component to Thumbtack - that should now now be used in place of this
   * To ensure backwards compatibility we need to apply the old styles here
   */
  const styles = { margin: '0 40px', padding: '0px', ...style };

  return <div className={`${className || ''} ${Classes.DRAWER_BODY}`} style={styles} {...rest} />;
}
